import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroBadges, heroImage, stats } from '../data/copy';
export function Hero() {
  return <header className="w-full bg-ink" data-id="element-86" data-mp="9k0gndfbepsa">
      <div className="mx-auto max-w-4xl px-6 pb-10 pt-8 text-center sm:pt-10" data-id="element-87" data-mp="9l33na9io82x">
        <Pill tone="gold" data-id="element-88" data-mp="4n1ov1j4iux9">Para entrenadores de atletismo</Pill>

        

        <h1 className="mx-auto mt-4 max-w-3xl font-display text-[2.3rem] font-bold leading-[1.05] text-ivory sm:text-5xl lg:text-[3.5rem]" style={{
        fontSize: "28px"
      }} data-id="element-89" data-mp="129qudld1bpnv">
          Planifica todo tu entrenamiento en{' '}
          <span className="text-gold" data-id="element-90" data-mp="s9zxjd104ykm">5 minutos</span>
        </h1>

        {/* El mockup va inmediatamente debajo de la promesa (el titular). */}
        <div className="relative mt-7" data-id="element-91" data-mp="3d1ikzavvpeny">
          <div className="absolute inset-x-0 bottom-8 top-10 rounded-4xl bg-coal" aria-hidden="true" data-id="element-92" data-mp="3d2l9xd9n5718" />
          <img src={heroImage} alt="El Megapack Atletismo 360 completo: estuche, 6 volúmenes técnicos y 5 bonos impresos." className="relative mx-auto w-full max-w-sm sm:max-w-xl lg:max-w-2xl" width={1240} height={1240} sizes="(max-width: 640px) 384px, (max-width: 1024px) 576px, 672px" decoding="async" loading="eager" {...{
          fetchpriority: 'high'
        }} data-id="element-93" data-mp="381e0zavri1sz" />
        </div>

        <p className="mx-auto mt-4 max-w-readable font-sans text-base leading-relaxed text-stone" style={{
        fontSize: "14px"
      }} data-id="element-94" data-mp="3e8mur4n88xh9">
          El sistema completo para entrenadores de atletismo en español: 6
          volúmenes técnicos, +70 sesiones listas para usar y 5 bonos
          exclusivos.
        </p>

        <div className="mt-7" data-id="element-95" data-mp="2qkwk90l5rzv6">
          <CtaButton href="#oferta" size="large" className="w-full sm:w-auto" data-id="element-96" data-mp="2qloea6z3xpjc">
            Acceso completo ahora
          </CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-97" data-mp="2hinbog9gagkf">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-stone sm:text-xs" data-id="element-98" data-mp="2lla9cxssyvpj">
              <CheckIcon className="h-3.5 w-3.5 text-gold" strokeWidth={2.6} aria-hidden="true" data-id="element-99" data-mp="s335feo1gqy2" />
              {badge}
            </li>)}
        </ul>
      </div>

      <dl className="border-y border-line bg-coal" data-id="element-100" data-mp="ic873bxiq0w9">
        <div className="mx-auto grid max-w-6xl grid-cols-3 divide-x divide-line px-6" data-id="element-101" data-mp="id03uq2uq4o4">
          {stats.map(stat => <div key={stat.label} className="px-3 py-7 text-center" data-id="element-102" data-mp="deq8ofh4n42i">
              <dt className="sr-only" data-id="element-103" data-mp="1b15qjidgu3ql">{stat.label}</dt>
              <dd data-id="element-104" data-mp="1ayji7gir3k7b">
                <span className="block font-display text-4xl font-bold leading-none text-gold sm:text-5xl" data-id="element-105" data-mp="1622irq63pjex">
                  {stat.value}
                </span>
                <span className="mt-2 block font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-stone sm:text-xs" data-id="element-106" data-mp="110wpnr8j3u4v">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </div>
      </dl>
    </header>;
}